//
// Copyright 2022 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/service/agentmanager.proto (package dxos.service.agentmanager, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_any, file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_dxos_config } from "../config_pb.js";
import type { Credential, Presentation } from "../halo/credentials_pb.js";
import { file_dxos_halo_credentials } from "../halo/credentials_pb.js";
import type { PublicKey } from "../keys_pb.js";
import { file_dxos_keys } from "../keys_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/service/agentmanager.proto.
 */
export const file_dxos_service_agentmanager: GenFile = /*@__PURE__*/
  fileDesc("Ch9keG9zL3NlcnZpY2UvYWdlbnRtYW5hZ2VyLnByb3RvEhlkeG9zLnNlcnZpY2UuYWdlbnRtYW5hZ2VyIkEKF0luaXRBdXRoU2VxdWVuY2VSZXF1ZXN0EhcKCmF1dGhfdG9rZW4YASABKAlIAIgBAUINCgtfYXV0aF90b2tlbiL3AgoYSW5pdEF1dGhTZXF1ZW5jZVJlc3BvbnNlEloKBnJlc3VsdBgBIAEoDjJKLmR4b3Muc2VydmljZS5hZ2VudG1hbmFnZXIuSW5pdEF1dGhTZXF1ZW5jZVJlc3BvbnNlLkluaXRBdXRoU2VxdWVuY2VSZXN1bHQSEgoFbm9uY2UYAiABKAxIAIgBARIzChBhZ2VudG1hbmFnZXJfa2V5GAMgASgLMhQuZHhvcy5rZXlzLlB1YmxpY0tleUgBiAEBEiYKGWluaXRfYXV0aF9yZXNwb25zZV9yZWFzb24YBCABKAlIAogBASJRChZJbml0QXV0aFNlcXVlbmNlUmVzdWx0EgsKB1VOS05PV04QABILCgdTVUNDRVNTEAESEgoOTk9UX0FVVEhPUklaRUQQAhIJCgVFUlJPUhADQggKBl9ub25jZUITChFfYWdlbnRtYW5hZ2VyX2tleUIcChpfaW5pdF9hdXRoX3Jlc3BvbnNlX3JlYXNvbiJLCg5BdXRoZW50aWNhdGlvbhI5CgxwcmVzZW50YXRpb24YASABKAsyIy5keG9zLmhhbG8uY3JlZGVudGlhbHMuUHJlc2VudGF0aW9uIn8KFEF1dGhlbnRpY2F0ZVJlc3BvbnNlEhIKBXRva2VuGAEgASgJSACIAQESOgoKY3JlZGVudGlhbBgCIAEoCzIhLmR4b3MuaGFsby5jcmVkZW50aWFscy5DcmVkZW50aWFsSAGIAQFCCAoGX3Rva2VuQg0KC19jcmVkZW50aWFsMvcBCgxBZ2VudE1hbmFnZXISewoQSW5pdEF1dGhTZXF1ZW5jZRIyLmR4b3Muc2VydmljZS5hZ2VudG1hbmFnZXIuSW5pdEF1dGhTZXF1ZW5jZVJlcXVlc3QaMy5keG9zLnNlcnZpY2UuYWdlbnRtYW5hZ2VyLkluaXRBdXRoU2VxdWVuY2VSZXNwb25zZRJqCgxBdXRoZW50aWNhdGUSKS5keG9zLnNlcnZpY2UuYWdlbnRtYW5hZ2VyLkF1dGhlbnRpY2F0aW9uGi8uZHhvcy5zZXJ2aWNlLmFnZW50bWFuYWdlci5BdXRoZW50aWNhdGVSZXNwb25zZUI6WjhnaXRodWIuY29tL2R4b3MvZHhvcy9wcm90by9kZWYvZHhvcy9zZXJ2aWNlL2FnZW50bWFuYWdlcmIGcHJvdG8z", [file_google_protobuf_any, file_google_protobuf_empty, file_dxos_config, file_dxos_halo_credentials, file_dxos_keys]);

/**
 * @generated from message dxos.service.agentmanager.InitAuthSequenceRequest
 */
export type InitAuthSequenceRequest = Message<"dxos.service.agentmanager.InitAuthSequenceRequest"> & {
  /**
   * Auth token for the agentmanager to validate authorization.
   *
   * @generated from field: optional string auth_token = 1;
   */
  authToken?: string;
};

/**
 * Describes the message dxos.service.agentmanager.InitAuthSequenceRequest.
 * Use `create(InitAuthSequenceRequestSchema)` to create a new message.
 */
export const InitAuthSequenceRequestSchema: GenMessage<InitAuthSequenceRequest> = /*@__PURE__*/
  messageDesc(file_dxos_service_agentmanager, 0);

/**
 * @generated from message dxos.service.agentmanager.InitAuthSequenceResponse
 */
export type InitAuthSequenceResponse = Message<"dxos.service.agentmanager.InitAuthSequenceResponse"> & {
  /**
   * @generated from field: dxos.service.agentmanager.InitAuthSequenceResponse.InitAuthSequenceResult result = 1;
   */
  result: InitAuthSequenceResponse_InitAuthSequenceResult;

  /**
   * @generated from field: optional bytes nonce = 2;
   */
  nonce?: Uint8Array;

  /**
   * @generated from field: optional dxos.keys.PublicKey agentmanager_key = 3;
   */
  agentmanagerKey?: PublicKey;

  /**
   * Reason why initializing the auth sequence failed (e.g. invalid access token)
   *
   * @generated from field: optional string init_auth_response_reason = 4;
   */
  initAuthResponseReason?: string;
};

/**
 * Describes the message dxos.service.agentmanager.InitAuthSequenceResponse.
 * Use `create(InitAuthSequenceResponseSchema)` to create a new message.
 */
export const InitAuthSequenceResponseSchema: GenMessage<InitAuthSequenceResponse> = /*@__PURE__*/
  messageDesc(file_dxos_service_agentmanager, 1);

/**
 * @generated from enum dxos.service.agentmanager.InitAuthSequenceResponse.InitAuthSequenceResult
 */
export enum InitAuthSequenceResponse_InitAuthSequenceResult {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: NOT_AUTHORIZED = 2;
   */
  NOT_AUTHORIZED = 2,

  /**
   * @generated from enum value: ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum dxos.service.agentmanager.InitAuthSequenceResponse.InitAuthSequenceResult.
 */
export const InitAuthSequenceResponse_InitAuthSequenceResultSchema: GenEnum<InitAuthSequenceResponse_InitAuthSequenceResult> = /*@__PURE__*/
  enumDesc(file_dxos_service_agentmanager, 1, 0);

/**
 * @generated from message dxos.service.agentmanager.Authentication
 */
export type Authentication = Message<"dxos.service.agentmanager.Authentication"> & {
  /**
   * @generated from field: dxos.halo.credentials.Presentation presentation = 1;
   */
  presentation?: Presentation;
};

/**
 * Describes the message dxos.service.agentmanager.Authentication.
 * Use `create(AuthenticationSchema)` to create a new message.
 */
export const AuthenticationSchema: GenMessage<Authentication> = /*@__PURE__*/
  messageDesc(file_dxos_service_agentmanager, 2);

/**
 * @generated from message dxos.service.agentmanager.AuthenticateResponse
 */
export type AuthenticateResponse = Message<"dxos.service.agentmanager.AuthenticateResponse"> & {
  /**
   * @generated from field: optional string token = 1;
   */
  token?: string;

  /**
   * @generated from field: optional dxos.halo.credentials.Credential credential = 2;
   */
  credential?: Credential;
};

/**
 * Describes the message dxos.service.agentmanager.AuthenticateResponse.
 * Use `create(AuthenticateResponseSchema)` to create a new message.
 */
export const AuthenticateResponseSchema: GenMessage<AuthenticateResponse> = /*@__PURE__*/
  messageDesc(file_dxos_service_agentmanager, 3);

/**
 * @generated from service dxos.service.agentmanager.AgentManager
 */
export const AgentManager: GenService<{
  /**
   * Initialize the authentication sequence. Send an optional authentication token to permit the server to authorize the request.
   * Receive a nonce (challenge) necessary to call Authenticate to prevent replay attacks.
   *
   * @generated from rpc dxos.service.agentmanager.AgentManager.InitAuthSequence
   */
  initAuthSequence: {
    methodKind: "unary";
    input: typeof InitAuthSequenceRequestSchema;
    output: typeof InitAuthSequenceResponseSchema;
  },
  /**
   * @generated from rpc dxos.service.agentmanager.AgentManager.Authenticate
   */
  authenticate: {
    methodKind: "unary";
    input: typeof AuthenticationSchema;
    output: typeof AuthenticateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dxos_service_agentmanager, 0);

